import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SystemApiService } from "@cv-invision/core";

@Injectable()
export class ChatBotService {

	BASE_URL = this.systemApiService.api.intelligenceService;

	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService) {
	}

	/**
	 * event to call APi to send message
	 * @param datasource
	 * @param data
	 */
	public sendMessage(datasource: string, data: any): Observable<any> {
		return this.httpClient.post(`${this.BASE_URL}class-assistant/ask/${datasource}`, data);
	}

	/**
	 * event to get data sources for class assistant
	 * @param orderId
	 */
	public getDataSources(orderId?: number): Observable<any> {
		let params = new HttpParams();

		if (orderId) {
			params = params.append('orderId', orderId);
		}

		return this.httpClient.get(`${this.BASE_URL}class-assistant/data-source-availables`, {params: params});
	}
}
